<template>
  <div class="wrapper flex-col">
    <!-- 查看习题详情 -->
    <el-dialog
      title="习题详情"
      :visible.sync="is_show_topic"
      width="50%"
      custom-class="topic_detail_dia"
    >
      <div>
        <div v-html="topic_detail.content"></div>
        <div>[答案]</div>
        <div v-html="topic_detail.answer"></div>
        <div>[解析]</div>
        <div v-html="topic_detail.analyzing"></div>
      </div>
    </el-dialog>
    <!-- 批量给分 -->
    <div></div>
    <div class="head flex-row-space-between">
      <div class="flex-center" @click="goBack">
        <img src="../../assets/images/course_2.0/返回.png" alt="" />
      </div>
      <div class="head_l">
        <div class="flex-center">
          <div class="head_l_title">{{ $route.query.homework_title }}</div>
        </div>
      </div>
      <div style="opacity: 0"></div>
    </div>
    <el-drawer
      title="批改"
      :visible.sync="drawer_correct"
      direction="ttb"
      size="100%"
      @opened="get_iframe()"
    >
      <div class="drawer_correct_canvas">
        <div class="correct_screen_list_item_head">
          <div v-if="popover_correct_type == '按人批改'">
            习题：{{ current_drawer_item_index + 1 + page_size * (current_page - 1) }}
          </div>
          <div v-if="popover_correct_type == '按题批改'">
            {{ current_drawer_item.name }}
          </div>
          <div style="position: absolute; right: 27%" class="gradeBox">
            <div class="tenBox flex-row-v-center">
              <div
                v-if="current_drawer_item.src_score >= data"
                v-for="(data, index) in tenList"
                :class="{
                  tenBoxItem: true,
                  'flex-center': true,
                  tenBoxItemActive: current_drawer_item.tenNum == data,
                }"
                :key="index"
                @click="getTenItem(data, current_drawer_item)"
              >
                {{ data }}
              </div>
            </div>
            <div class="flex-row">
              <div class="unitList flex-row-center">
                <div
                  :class="{
                    unitListItem: true,
                    'flex-center': true,
                    unitListItemActive:
                      current_drawer_item.unitNum == 0 &&
                      current_drawer_item.tenNum == '' &&
                      current_drawer_item.decimal == '',
                  }"
                  @click="getScore2(current_drawer_item, 0)"
                >
                  0
                </div>
                <div
                  v-if="current_drawer_item.src_score >= data"
                  v-for="(data, index) in unitList"
                  :class="{
                    unitListItem: true,
                    'flex-center': true,
                    unitListItemActive: current_drawer_item.unitNum == data,
                  }"
                  :key="index"
                  @click="getUnitItem(data, current_drawer_item)"
                >
                  {{ data }}
                </div>
              </div>
              <div
                :class="{
                  scoreBox: true,
                  scoreBoxActive: current_drawer_item.decimal == 0.5,
                }"
                @click="getScore(0.5, current_drawer_item)"
              >
                0.5
              </div>
            </div>
          </div>
          <div class="correct_screen_list_item_head_opreation">
            <div @click="last_img()">
              <span class="iconfont iconxiangzuojiantou"></span>
            </div>
            <div @click="next_img()">
              <span class="iconfont iconxiangyoujiantou"></span>
            </div>
            <div @click="blow_up()">
              <span class="iconfont el-icon-zoom-in"></span>
            </div>
            <div @click="blow_down()">
              <span class="iconfont el-icon-zoom-out"></span>
            </div>
            <div @click="canvas_rotate()">
              <span class="iconfont iconxuanzhuan2"></span>
            </div>
            <div
              :class="
                show_canvas_operation_type == 'pen'
                  ? 'show_canvas_operation_type_active'
                  : ''
              "
              @click="open_close_pen()"
            >
              <span class="iconfont iconpigai1"></span>
            </div>
            <div
              :class="
                show_canvas_operation_type == 'eraser'
                  ? 'show_canvas_operation_type_active'
                  : ''
              "
              @click="eraser()"
            >
              <span class="iconfont iconxiangpi1"></span>
            </div>
            <div @click="canvas_remove()">
              <span class="iconfont iconshanchu4"></span>
            </div>
            <div @click="save_canvas_imglise()"><span>保存</span></div>
          </div>
        </div>
        <div class="correct_screen_list_item_main_box">
          <div style="height: 1px"></div>
          <div class="correct_screen_list_item_canvas">
            <iframe
              src="https://www.gaokaowin.com/myCanvas/online/newCanvas.html"
              width="100%"
              height="100%"
              ref="newCanvas"
              name="newCanvas"
              id="newCanvas"
            ></iframe>
            <!-- <iframe
              src="http://localhost:8091/newCanvas.html"
              width="100%"
              height="100%"
              ref="newCanvas"
              name="newCanvas"
              id="newCanvas"
            ></iframe> -->
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 作业批改样式修改 -->
    <div class="flex-row content_box">
      <div class="content_right flex-col">
        <div class="content_right_head flex-row-space-between">
          <div
            class="flex-col-v-center"
            @click="
              popover_correct_type = '按题批改';
              change_correct_type('按题批改');
            "
          >
            <span
              :class="{
                content_right_head_active: popover_correct_type == '按题批改',
              }"
              >按题批</span
            >
            <div style="height: 5px">
              <div
                v-show="popover_correct_type == '按题批改'"
                class="content_right_head_item_line"
              ></div>
            </div>
          </div>
          <div
            class="flex-col-v-center"
            @click="
              popover_correct_type = '按人批改';
              change_correct_type('按人批改');
            "
          >
            <span
              :class="{
                content_right_head_active: popover_correct_type == '按人批改',
              }"
              >挑人批</span
            >
            <div style="height: 5px">
              <div
                v-show="popover_correct_type == '按人批改'"
                class="content_right_head_item_line"
              ></div>
            </div>
          </div>
        </div>
        <div class="content_right_content">
          <div v-show="popover_correct_type == '按题批改'">
            <div class="content_right_content_title">习题列表</div>
            <div class="content_right_content_list flex-row">
              <div
                @click="change_topic_index(item, index)"
                :class="{
                  content_right_content_list_item: true,
                  'flex-center': true,
                  content_right_content_list_item_active: topic_highlight == index,
                }"
                v-for="(item, index) in topic_list"
                :key="index"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <div v-show="popover_correct_type == '按人批改'">
            <div class="content_right_content_title">学生列表</div>
            <div class="student_list">
              <div
                :class="{
                  student_item: true,
                  student_item_active: student_highlight == index,
                  student_item_error: item.status != 20 && structure_type == 6,
                }"
                @click="change_student(item, index)"
                v-for="(item, index) in student_list"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_left flex-col">
        <!-- 上一张下一张 -->
        <div class="lastBox" @click="last" v-if="popover_split_screen_type == '单屏显示'">
          <img src="../../assets/images/course_2.0/last.png" alt="" />
        </div>
        <div class="nextBox" @click="next" v-if="popover_split_screen_type == '单屏显示'">
          <img src="../../assets/images/course_2.0/next.png" alt="" />
        </div>
        <div class="content_left_head flex-row-v-center">
          <!-- 批改进度 -->
          <!-- <div class="content_left_head_box">
            <div>
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course"
                v-model="popover_split_screen_show"
              >
                <div
                  slot="reference"
                  class="course_creat_sort_btn"
                  style="cursor: pointer"
                >
                  {{ popover_split_screen_type }}
                  <i
                    :class="
                      popover_split_screen_show
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                  ></i>
                </div>
                <div class="course_creat_sort_options">
                  <div
                    :class="{
                      color_active: popover_split_screen_type == '单屏显示',
                    }"
                    @click="
                      popover_split_screen_type = '单屏显示';
                      popover_split_screen_show = false;
                      change_page_size(1);
                    "
                  >
                    单屏显示
                  </div>
                  <div
                    :class="{
                      color_active: popover_split_screen_type == '双屏显示',
                    }"
                    @click="
                      popover_split_screen_type = '双屏显示';
                      popover_split_screen_show = false;
                      change_page_size(2);
                    "
                  >
                    双屏显示
                  </div>
                  <div
                    :class="{
                      color_active: popover_split_screen_type == '四屏显示',
                    }"
                    @click="
                      popover_split_screen_type = '四屏显示';
                      popover_split_screen_show = false;
                      change_page_size(4);
                    "
                  >
                    四屏显示
                  </div>
                  <div
                    :class="{
                      color_active: popover_split_screen_type == '六屏显示',
                    }"
                    @click="
                      popover_split_screen_type = '六屏显示';
                      popover_split_screen_show = false;
                      change_page_size(6);
                    "
                  >
                    六屏显示
                  </div>
                  <div
                    :class="{
                      color_active: popover_split_screen_type == '八屏显示',
                    }"
                    @click="
                      popover_split_screen_type = '八屏显示';
                      popover_split_screen_show = false;
                      change_page_size(8);
                    "
                  >
                    八屏显示
                  </div>
                </div>
              </el-popover>
            </div>
          </div> -->
          <div class="flex-row">
            <div class="head_l_percentage_title">批改进度</div>
            <div class="head_l_percentage_bar">
              <el-progress
                :percentage="correct_progress"
                :format="return_percentage"
              ></el-progress>
            </div>
          </div>
          <div class="flex-row-v-center">
            显示份数:
            <div
              :class="{
                pageItem: true,
                pageItemActive: popover_split_screen_type == '单屏显示',
              }"
              @click="
                popover_split_screen_type = '单屏显示';
                popover_split_screen_show = false;
                change_page_size(1);
              "
            >
              1
            </div>
            <div
              :class="{
                pageItem: true,
                pageItemActive: popover_split_screen_type == '双屏显示',
              }"
              @click="
                popover_split_screen_type = '双屏显示';
                popover_split_screen_show = false;
                change_page_size(2);
              "
            >
              2
            </div>
            <div
              :class="{
                pageItem: true,
                pageItemActive: popover_split_screen_type == '四屏显示',
              }"
              @click="
                popover_split_screen_type = '四屏显示';
                popover_split_screen_show = false;
                change_page_size(4);
              "
            >
              4
            </div>
            <div
              :class="{
                pageItem: true,
                pageItemActive: popover_split_screen_type == '六屏显示',
              }"
              @click="
                popover_split_screen_type = '六屏显示';
                popover_split_screen_show = false;
                change_page_size(6);
              "
            >
              6
            </div>
            <div
              :class="{
                pageItem: true,
                pageItemActive: popover_split_screen_type == '八屏显示',
              }"
              @click="
                popover_split_screen_type = '八屏显示';
                popover_split_screen_show = false;
                change_page_size(8);
              "
            >
              8
            </div>
          </div>
          <el-popover
            placement="left-start"
            trigger="hover"
            popper-class="area_popper_batch_set_score"
            v-if="popover_correct_type == '按题批改'"
          >
            <div slot="reference" class="batch_set_score" style="cursor: pointer">
              批量给分
            </div>
            <div>
              <div class="correct_screen_list_item_foot_opreation_mark flex-col">
                <div class="tenBox flex-row-v-center">
                  <div
                    v-if="src_score >= data"
                    v-for="(data, index) in tenList"
                    :class="{
                      tenBoxItem: true,
                      'flex-center': true,
                      tenBoxItemActive: tenNum == data,
                    }"
                    :key="index"
                    @click="getTenItemAll(data)"
                  >
                    {{ data }}
                  </div>
                </div>
                <div class="flex-row-center">
                  <div class="unitList flex-row-center">
                    <div
                      :class="{
                        unitListItem: true,
                        'flex-center': true,
                        unitListItemActive: unitNum == 0 && decimal == '' && tenNum == '',
                      }"
                      @click="getScoreAll2(0)"
                    >
                      0
                    </div>
                    <div
                      v-if="src_score >= data"
                      v-for="(data, index) in unitList"
                      :class="{
                        unitListItem: true,
                        'flex-center': true,
                        unitListItemActive: unitNum == data,
                      }"
                      :key="index"
                      @click="getUnitItemAll(data)"
                    >
                      {{ data }}
                    </div>
                  </div>
                  <div
                    :class="{
                      scoreBox: true,
                      scoreBoxActive: decimal == 0.5,
                    }"
                    @click="getScoreAll(0.5)"
                  >
                    0.5
                  </div>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="correct_screen_list">
          <div
            v-if="current_student_usages_json_spilt[current_page - 1].length"
            v-for="(item, index) in current_student_usages_json_spilt[current_page - 1]"
            :key="index"
            class="screen_split_item"
            :class="
              popover_split_screen_type == '单屏显示'
                ? 'creen_split_1'
                : popover_split_screen_type == '双屏显示'
                ? 'creen_split_2'
                : popover_split_screen_type == '四屏显示'
                ? 'creen_split_4'
                : popover_split_screen_type == '六屏显示'
                ? 'creen_split_6'
                : 'creen_split_8'
            "
          >
            <!-- <div class="correct_screen_list_item_head">
              <div v-if="popover_correct_type == '按人批改'">
                习题：{{ index + 1 + page_size * (current_page - 1) }}
              </div>
              <div v-if="popover_correct_type == '按题批改'">
                {{ item.name }}
              </div>
              <div class="correct_screen_list_item_head_opreation">
              </div>
            </div> -->
            <div
              class="correct_screen_list_item_main_box"
              :style="{ 'border-color': !item.score ? 'red' : '#69B4FF' }"
            >
              <div style="height: 1px"></div>
              <div class="correct_screen_list_item_canvas">
                <el-image
                  @click="drawer_student_answer(index_url, item, index)"
                  v-for="(url, index_url) in item.student_answer"
                  :key="index_url"
                  :src="
                    url.thumbnail ||
                    (item.student_answer_small[index_url]
                      ? item.student_answer_small[index_url].image
                      : url.image)
                  "
                ></el-image>
              </div>
              <!-- <div class="correct_screen_list_item_foot_opreation" v-if="$route.query.structure_type==4"> -->
              <div class="correct_screen_list_item_foot_opreation">
                <div></div>
                <div style="margin: 5px 2px" class="flex-row-space-between">
                  <div class="flex-row-v-center">
                    <div
                      v-if="popover_correct_type == '按人批改'"
                      style="margin-right: 10px;color:red"
                    >
                      习题：{{ index + 1 + page_size * (current_page - 1) }}
                    </div>
                    <div
                      v-if="popover_correct_type == '按题批改'"
                      style="margin-right: 10px;color:red"
                    >
                      {{ item.name }}
                    </div>
                    <!-- <el-input-number v-model="item.score" :step="0.5" :precision="1" :min='0' :max="item.src_score||8" @change="correct_score(item,item.score)"></el-input-number> -->
                    <span
                      >当前/总分:<el-input-number
                        @change="onScoring(item, item.score)"
                        :max="item.src_score"
                        size="small"
                        v-model="item.score"
                        :step="0.5"
                        :controls="false"
                        style="width: 100px"
                      ></el-input-number
                      >/{{ item.src_score }}</span
                    >
                  </div>
                  <div class="flex-row-v-center">
                    <div
                      class="correct_screen_list_item_foot_opreation_show_topic"
                      @click="show_topic(item)"
                    >
                      习题
                    </div>
                    <div
                      class="correct_screen_list_item_foot_opreation_show_topic"
                      @click="drawer_student_answer(index_url, item, index)"
                    >
                      全屏
                    </div>
                  </div>
                </div>

                <div class="gradeBox">
                  <div class="tenBox flex-row-v-center">
                    <div
                      v-if="item.src_score >= data"
                      v-for="(data, index) in tenList"
                      :class="{
                        tenBoxItem: true,
                        'flex-center': true,
                        tenBoxItemActive: item.tenNum == data,
                      }"
                      :key="index"
                      @click="getTenItem(data, item)"
                    >
                      {{ data }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="unitList flex-row-center">
                      <div
                        :class="{
                          unitListItem: true,
                          'flex-center': true,
                          unitListItemActive:
                            item.unitNum == 0 && item.tenNum == '' && item.decimal == '',
                        }"
                        @click="getScore2(item, 0)"
                      >
                        0
                      </div>
                      <div
                        v-if="item.src_score >= data"
                        v-for="(data, index) in unitList"
                        :class="{
                          unitListItem: true,
                          'flex-center': true,
                          unitListItemActive: item.unitNum == data,
                        }"
                        :key="index"
                        @click="getUnitItem(data, item)"
                      >
                        {{ data }}
                      </div>
                    </div>
                    <div
                      :class="{
                        scoreBox: true,
                        scoreBoxActive: item.decimal == 0.5,
                      }"
                      @click="getScore(0.5, item)"
                    >
                      0.5
                    </div>
                  </div>
                </div>
                <!-- <div class="correct_screen_list_item_foot_opreation_save" > </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="foot_page" style="text-align: right">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="page_size"
            :total="total"
            @current-change="changePage"
            :current-page="current_page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../../plugins/Bus";
// import app_richText from "../../components/rich/app_richText.vue";
import ifram from "../../components/ifarm/ifarm";
export default {
  components: { ifram },
  data() {
    return {
      corrected_num: 0,
      all_num: 0,
      correct_progress: 0,
      topic_detail: {},
      is_show_topic: false,
      student_list: [],
      homework_class_json_info: {},
      topic_list: [],
      head_l_topic_index_list_show_icon: false,
      popover_split_screen_show: false,
      popover_split_screen_type: "四屏显示",
      page_size: 1,
      total: 0,
      current_page: 1,
      popover_correct_type_show: false,
      popover_correct_type: "按题批改",
      current_student_usages_json: [], //当前学生习题列表
      current_student_usages_json_spilt: [], //按每页条数分割后的当前学生习题列表
      popover_correct_student_list_show: false,
      show_corrected_students: false, //显示已批改的学生
      drawer_correct: false,
      current_drawer_item: [], //当前批改的
      current_drawer_item_index: 0, //学生习题 index
      current_drawer_item_index_answer: 0, //学生答案index
      show_canvas_operation_type: "pen",
      topic_highlight: -1,
      student_highlight: 0,
      school_url: "",
      tenList: [10, 20, 30, 40, 50, 60, 70, 80, 90],
      unitList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      tenNum: null,
      unitNum: null,
      decimal: null,
      src_score: "",
      structure_type: "",
    };
  },
  mounted() {
    this.get_homework_lsit();
    this.change_page_size(8);
    this.school_url = JSON.parse(sessionStorage.userInfo).school.server_url;
    this.structure_type = this.$route.query.structure_type;
    window.save_canvas_imglise_upload_data = this.save_canvas_imglise_upload_data;
  },
  methods: {
    last() {
      if (this.current_page == 1) {
        this.$message({
          type: "warning",
          message: "已经是第一张了",
          duration: 1500,
          showClose: true,
        });
        return;
      }
      this.current_page = this.current_page - 1;
      this.changePage(this.current_page);
    },
    next() {
      if (this.current_page == this.total) {
        this.$message({
          type: "warning",
          message: "已经是最后一张了",
          duration: 1500,
          showClose: true,
        });
        return;
      }
      this.current_page = this.current_page + 1;
      this.changePage(this.current_page);
    },
    //退出
    goBack() {
      this.$router.push("/homework?active=1");
    },

    //批量打分
    getTenItemAll(data) {
      if (data == this.tenNum) {
        this.tenNum = "";
        let score =
          Number(this.tenNum || 0) +
          Number(this.unitNum || 0) +
          Number(this.decimal || 0);
        if (score > this.src_score) {
          this.$message({
            type: "error",
            message: `满分为${this.src_score}分,请选择正确的分数`,
            durtion: 1500,
            showClose: true,
          });
          return;
        }
        this.set_score_all(score, 0);
        return;
      } else {
        this.tenNum = data;
        this.unitNum = "";
        this.decimal = "";
      }
      let score =
        Number(this.tenNum || 0) + Number(this.unitNum || 0) + Number(this.decimal || 0);
      if (score > this.src_score) {
        this.$message({
          type: "error",
          message: `满分为${this.src_score}分,请选择正确的分数`,
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.set_score_all(score, 0);
    },
    getUnitItemAll(data) {
      if (data == this.unitNum) {
        this.unitNum = "";
        let score =
          Number(this.tenNum || 0) +
          Number(this.unitNum || 0) +
          Number(this.decimal || 0);
        if (score > this.src_score) {
          this.$message({
            type: "error",
            message: `满分为${this.src_score}分,请选择正确的分数`,
            durtion: 1500,
            showClose: true,
          });
          return;
        }
        this.set_score_all(score, 0);
        return;
      } else {
        this.unitNum = data;
      }
      let score = Number(this.tenNum) + Number(this.unitNum) + Number(this.decimal);
      if (score > this.src_score) {
        this.$message({
          type: "error",
          message: `满分为${this.src_score}分,请选择正确的分数`,
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.set_score_all(score, 0);
    },
    getScoreAll(data) {
      if (data == this.decimal) {
        this.decimal = "";
      } else {
        this.decimal = data;
      }
      let score = Number(this.tenNum) + Number(this.unitNum) + Number(this.decimal);
      if (score > this.src_score) {
        this.$message({
          type: "error",
          message: `满分为${this.src_score}分,请选择正确的分数`,
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.set_score_all(score, 0);
    },
    getScoreAll2() {
      this.decimal = "";
      this.unitNum = 0;
      this.tenNum = "";
      this.set_score_all(0, 0);
    },
    //打分
    onScoring(item, score) {
      if (score % 0.5 != 0) {
        score = Math.round(Number(score));
      }
      item.score = score;
      if (score < 10) {
        if (score % 1 != 0) {
          item.tenNum = "";
          item.unitNum = parseInt(score);
          item.decimal = 0.5;
        } else {
          item.tenNum = "";
          item.unitNum = score;
          item.decimal = "";
        }
      } else {
        if (score % 1 != 0) {
          item.tenNum = parseInt(score / 10) * 10;
          item.unitNum = parseInt(score % 10);
          item.decimal = 0.5;
        } else {
          item.tenNum = parseInt(score / 10) * 10;
          item.unitNum = score % 10;
        }
      }

      this.correct_score(item, score);
    },

    //打分十位数
    getTenItem(data, item) {
      if (data == item.tenNum) {
        item.tenNum = "";
        let score =
          Number(item.tenNum || 0) +
          Number(item.unitNum == -1 ? 0 : item.unitNum) +
          Number(item.decimal || 0);
        if (score > item.src_score) {
          this.$message({
            type: "error",
            message: `满分为${item.src_score}分,请选择正确的分数`,
            durtion: 1500,
            showClose: true,
          });
          return;
        }
        this.correct_score(item, score);
        return;
      } else {
        item.tenNum = data;
        item.unitNum = 0;
        item.decimal = "";
        let score =
          Number(item.tenNum || 0) +
          Number(item.unitNum == -1 ? 0 : item.unitNum) +
          Number(item.decimal || 0);
        if (score > item.src_score) {
          this.$message({
            type: "error",
            message: `满分为${item.src_score}分,请选择正确的分数`,
            durtion: 1500,
            showClose: true,
          });
          return;
        }
        this.correct_score(item, score);
      }
    },
    //打分个位数
    getUnitItem(data, item) {
      if (data == item.unitNum) {
        item.unitNum = "";
        let score =
          Number(item.tenNum || 0) +
          Number(item.unitNum || 0) +
          Number(item.decimal || 0);
        if (score > item.src_score) {
          this.$message({
            type: "error",
            message: `满分为${item.src_score}分,请选择正确的分数`,
            durtion: 1500,
            showClose: true,
          });
          return;
        }
        this.correct_score(item, score);
        return;
      } else {
        item.unitNum = data;
      }
      let score =
        Number(item.tenNum || 0) + Number(item.unitNum || 0) + Number(item.decimal || 0);
      if (score > item.src_score) {
        this.$message({
          type: "error",
          message: `满分为${item.src_score}分,请选择正确的分数`,
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.correct_score(item, score);
    },
    getScore2(item) {
      item.tenNum = "";
      item.decimal = "";
      item.unitNum = 0;
      this.correct_score(item, 0);
    },
    getScore(data, item) {
      if (data == item.decimal) {
        item.decimal = "";
      } else {
        item.decimal = data;
      }
      let score =
        Number(item.tenNum || 0) + Number(item.unitNum || 0) + Number(item.decimal || 0);
      if (score > item.src_score) {
        this.$message({
          type: "error",
          message: `满分为${item.src_score}分,请选择正确的分数`,
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.correct_score(item, score);
    },

    //查看习题详情
    show_topic(item) {
      // console.log(item)
      this.topic_detail = item;

      this.is_show_topic = true;
    },
    //批量打分
    set_score_all(score, i, length) {
      let arr = this.current_student_usages_json_spilt[this.current_page - 1];
      if (arr.length) {
        var formData = new FormData();
        formData.append("usages_id", arr[i].usage_id);
        formData.append("path", arr[i].path);
        formData.append("score", score);
        this.axios.post(`/school/Homework_Usages/submitScore`, formData).then((res) => {
          if (res.data.code == 1) {
            arr[i].score = score;
            this.$message({
              type: "success",
              message: "操作成功",
              durtion: 1500,
              showClose: true,
            });
            let tenNum = "";
            let unitNum = "";
            let decimal = "";
            if (score < 10) {
              if (score % 1 != 0) {
                tenNum = "";
                unitNum = parseInt(score);
                decimal = 0.5;
              } else {
                tenNum = "";
                unitNum = score;
                decimal = "";
              }
            } else {
              if (score % 1 != 0) {
                tenNum = parseInt(score / 10) * 10;
                unitNum = parseInt(score % 10);
                decimal = 0.5;
              } else {
                tenNum = parseInt(score / 10) * 10;
                unitNum = score % 10;
              }
            }
            this.current_student_usages_json_spilt[this.current_page - 1][
              i
            ].tenNum = tenNum;
            this.current_student_usages_json_spilt[this.current_page - 1][
              i
            ].unitNum = unitNum;
            this.current_student_usages_json_spilt[this.current_page - 1][
              i
            ].decimal = decimal;
            this.cacl_correct_progress();
            this.cacl_correct_student();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              durtion: 1500,
              showClose: true,
            });
          }
          if (++i < arr.length) {
            this.set_score_all(score, i, arr.length);
            // this.tenNum = "";
            // this.unitNum = "";
            // this.decimal = "";
          }
        });
      }
    },
    //图片进入批改
    //判断画板是否就绪
    get_iframe() {
      let _this = this;
      const iframe = _this.$refs.newCanvas;
      // 处理兼容行问题
      console.log(iframe, _this.current_drawer_item);
      setTimeout(function () {
        _this.call_iframe(_this.current_drawer_item.student_answer, "setImgList");
        // _this.call_iframe(_this.current_drawer_item_index_answer,'setImgIndex')
        _this.call_iframe("", "touchOpen");
        _this.call_iframe(
          {
            width: document.getElementById("newCanvas").clientWidth,
            height: document.getElementById("newCanvas").clientHeight,
          },
          "canvasChange"
        );
        //  console.log(document.getElementById('newCanvas').clientHeight)
        //  console.log(document.getElementById('newCanvas').clientWidth)
      }, 1000);

      return;
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function () {
          // iframe加载完毕以后执行操作
          console.log("iframe已加载完毕");
          _this.call_iframe(
            _this.current_drawer_item.student_answer,
            "setImgList",
            "newCanvas"
          );
          // _this.call_iframe('','touchOpen')
        });
      } else {
        iframe.onload = function () {
          // iframe加载完毕以后执行操作
          console.log("iframe已加载完毕");
          _this.call_iframe(
            _this.current_drawer_item.student_answer,
            "setImgList",
            "newCanvas"
          );
          // _this.call_iframe('','touchOpen')
        };
      }
    },
    drawer_student_answer(index_answer, item, index) {
      this.current_drawer_item = item;

      this.current_drawer_item_index = index;
      this.current_drawer_item_index_answer = index_answer;
      this.drawer_correct = true;
      //Document.domain = 'gaokaowin.com'
    },
    last_img() {
      if (this.current_drawer_item_index_answer > 0) {
        this.current_drawer_item_index_answer = this.current_drawer_item_index_answer - 1;
        this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
      } else {
        this.$message({
          type: "error",
          message: "已经是第一张了！",
          durtion: 1500,
          showClose: true,
        });
      }

      // this.call_iframe('','canvasChange')
    },
    next_img() {
      if (
        this.current_drawer_item_index_answer <
        this.current_drawer_item.student_answer.length - 1
      ) {
        this.current_drawer_item_index_answer = this.current_drawer_item_index_answer + 1;
        this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
      } else {
        this.$message({
          type: "error",
          message: "已经是最后张了！",
          durtion: 1500,
          showClose: true,
        });
      }
    },
    // 画笔
    open_close_pen() {
      if (this.show_canvas_operation_type == "pen") {
        this.call_iframe("", "touchClose");
        this.show_canvas_operation_type = "";
      } else {
        this.call_iframe("", "touchOpen");
        this.show_canvas_operation_type = "pen";
      }
      // this.call_iframe('','canvasChange')
    },
    // 放大
    blow_up() {
      // window.frames['newCanvas'].webFunction()
      this.call_iframe("", "ratio1");
      // this.call_iframe('','canvasChange')
    },
    blow_down() {
      this.call_iframe("", "ratio2");
    },
    canvas_rotate() {
      this.call_iframe("", "rotate1");
    },
    eraser() {
      this.call_iframe("", "erase");
      this.call_iframe("", "doeErase");
      this.show_canvas_operation_type = "eraser";
    },
    canvas_remove() {
      this.call_iframe("", "eraseAll");
    },
    //切换习题
    change_topic_index(item, index) {
      if (this.popover_correct_type == "按题批改") {
        this.current_student_usages_json = item.student_usages_json;
        this.change_page_size(this.page_size);
        this.topic_highlight = index;
        this.student_highlight = -1;
      }
    },
    // 切换学生
    change_student(item, index) {
      if (item.status != 20 && this.structure_type == 6) {
        this.$router.push(
          `/choicePaper?batch_id_by_class=${item.batch_id_by_class}&homework_src_uuid=${item.homework_src_uuid}&student_id=${item.id}&homework_name=${item.homework_name}`
        );
      } else {
        if (this.popover_correct_type == "按人批改") {
          for (let i in item.student_usages_json) {
            let tenNum = "";
            let unitNum = "";
            let decimal = "";
            if (item.student_usages_json[i].score < 10) {
              if (item.student_usages_json[i].score % 1 != 0) {
                tenNum = "";
                unitNum = parseInt(item.student_usages_json[i].score);
                decimal = 0.5;
              } else {
                tenNum = "";
                unitNum = item.student_usages_json[i].score;
                decimal = "";
              }
            } else {
              if (item.student_usages_json[i].score % 1 != 0) {
                tenNum = parseInt(item.student_usages_json[i].score / 10) * 10;
                unitNum = parseInt(item.student_usages_json[i].score % 10);
                decimal = 0.5;
              } else {
                tenNum = parseInt(item.student_usages_json[i].score / 10) * 10;
                unitNum = item.student_usages_json[i].score % 10;
              }
            }
            item.student_usages_json[i].tenNum = tenNum;
            item.student_usages_json[i].unitNum = unitNum;
            item.student_usages_json[i].decimal = decimal;
          }
          this.current_student_usages_json = item.student_usages_json;
          this.change_page_size(this.page_size);
          this.student_highlight = index;
          this.topic_highlight = -1;
          this.popover_correct_student_list_show = false;
        }
      }
    },
    //批改方式切换
    change_correct_type() {
      this.get_homework_lsit();
    },
    //翻页
    changePage(pageNum) {
      console.log(pageNum);
      this.current_page = pageNum;
    },
    async change_page_size(page_size) {
      var _this = this;
      this.page_size = page_size;
      this.current_page = 1;
      // let current_student_usages_json_spilt=this.group(JSON.parse(JSON.stringify(this.current_student_usages_json)),page_size );
      let current_student_usages_json_spilt = await this.group(
        this.current_student_usages_json,
        page_size
      );
      this.current_student_usages_json_spilt = current_student_usages_json_spilt;
      this.current_student_usages_json_spilt.forEach((item) => {
        item.forEach((data) => {
          if (data.score == -1) {
            data.score = undefined;
          }
        });
      });

      if (this.popover_correct_type == "按题批改") {
        if (this.current_student_usages_json_spilt[0]) {
          this.src_score = this.current_student_usages_json_spilt[0][0].src_score;
        }
      }
    },
    // 封装调用iframe方法
    call_iframe(data, event) {
      window.messageObj = {
        data: data,
        event: event,
      };
      console.log(window.frames["newCanvas"], "=============");
      window.frames["newCanvas"].webFunction();
    },
    //根据每页条数划分学生人数数组
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    // 自定义进度条
    return_percentage() {
      return this.corrected_num + "/" + this.all_num;
    },
    // 获取作业列表
    get_homework_lsit() {
      var formData = new FormData();
      formData.append("class_id", this.$route.query.class_id);
      formData.append("batch_id", this.$route.query.batch_id);
      formData.append("structure_type", this.$route.query.structure_type);
      this.axios
        .post(`/school/Homework_Usages/homeworkUsagesStatusList`, formData)
        .then((res) => {
          if (res.data.code == 1) {
            this.current_page = 1;
            let student_list = res.data.data.data;
            let arr_topic = [];
            for (let i in student_list) {
              let student_usages_json = JSON.parse(student_list[i].student_usages_json);
              let arr = [];
              for (let j in student_usages_json) {
                for (let h in student_usages_json[j].topicList) {
                  // console.log(student_usages_json[j].topicList[h])
                  if (student_usages_json[j].topicList[h].teacher_answer) {
                  } else {
                    student_usages_json[j].topicList[h].teacher_answer = [];
                  }
                  student_usages_json[j].topicList[h].usage_id = student_list[i].id;
                  if (
                    student_usages_json[j].topicList[h].is_unique == "" ||
                    student_usages_json[j].topicList[h].is_unique == 0 ||
                    Array.isArray(student_usages_json[j].topicList[h].score)
                  ) {
                    if (Array.isArray(student_usages_json[j].topicList[h].score)) {
                      student_usages_json[j].topicList[h].answer =
                        student_usages_json[j].topicList[h].answer;

                      student_usages_json[j].topicList[h].is_unique = JSON.parse(
                        student_usages_json[j].topicList[h].is_unique
                      );
                      for (let index in student_usages_json[j].topicList[h].answer) {
                        if (
                          student_usages_json[j].topicList[h].is_unique[index] == "" ||
                          student_usages_json[j].topicList[h].is_unique[index] == 0
                        ) {
                          let obj = {
                            answer: student_usages_json[j].topicList[h].answer[index],
                            path:
                              student_usages_json[j].topicList[h].children_path[index],
                            content: student_usages_json[j].topicList[h].content,
                            src_score:
                              student_usages_json[j].topicList[h].childScore[index],
                            name: "主观题",
                            score: student_usages_json[j].topicList[h].score[index],
                            student_answer:
                              student_usages_json[j].topicList[h].student_answer[index],
                            student_answer_small: [
                              student_usages_json[j].topicList[h].student_answer_small[0],
                            ],
                            teacher_answer:
                              student_usages_json[j].topicList[h].student_answer[index],
                            usage_id: student_usages_json[j].topicList[h].usage_id,
                          };
                          arr.push(obj);
                        }
                      }
                    } else {
                      arr.push(student_usages_json[j].topicList[h]);
                    }
                  }
                  if (i == 0) {
                    if (
                      student_usages_json[j].topicList[h].is_unique == "" ||
                      student_usages_json[j].topicList[h].is_unique == 0 ||
                      Array.isArray(student_usages_json[j].topicList[h].score)
                    ) {
                      if (Array.isArray(student_usages_json[j].topicList[h].score)) {
                        for (let index in student_usages_json[j].topicList[h].answer) {
                          if (
                            student_usages_json[j].topicList[h].is_unique[index] == "" ||
                            student_usages_json[j].topicList[h].is_unique[index] == 0
                          ) {
                            let obj = {
                              answer: student_usages_json[j].topicList[h].answer[index],
                              path:
                                student_usages_json[j].topicList[h].children_path[index],
                              src_score:
                                student_usages_json[j].topicList[h].childScore[index],
                              content: student_usages_json[j].topicList[h].content,
                              name: "主观题",
                              score: student_usages_json[j].topicList[h].score[index],
                              student_answer:
                                student_usages_json[j].topicList[h].student_answer[index],
                              student_answer_small: [
                                student_usages_json[j].topicList[h]
                                  .student_answer_small[0],
                              ],
                              teacher_answer:
                                student_usages_json[j].topicList[h].student_answer[index],
                              usage_id: student_usages_json[j].topicList[h].usage_id,
                            };
                            arr_topic.push(obj);
                          }
                        }
                      } else {
                        arr_topic.push(student_usages_json[j].topicList[h]);
                      }
                    }
                  }
                }
              }
              // if (student_list[i].status != 20) {
              //   for (let i in arr) {
              //     arr[i].status = 1;
              //   }
              //   student_list[i].student_usages_json = arr;
              // } else {
              //   student_list[i].student_usages_json = arr;
              // }

              student_list[i].student_usages_json = arr;
            }

            // return
            this.student_list = student_list;
            for (let i = 0; i < student_list.length; i++) {
              if (
                !student_list[i].student_usages_json.length &&
                student_list[i].status == 20
              ) {
                student_list.splice(i, 1);
                i--;
              }
            }
            if (!student_list.length) {
              return;
            }
            this.cacl_correct_progress(); //计算批改进度
            this.cacl_correct_student(); //查看学生是否批改完成

            //处理 按题批改数据
            for (let i in arr_topic) {
              let tenNum = "";
              let unitNum = "";
              let decimal = "";
              arr_topic[i].student_usages_json = [];
              for (let j in student_list) {
                let student_usages_json = student_list[j].student_usages_json;
                for (let h in student_usages_json) {
                  console.log(student_usages_json[h]);
                  if (i == h) {
                    if (student_usages_json[h].score < 10) {
                      if (student_usages_json[h].score % 1 != 0) {
                        tenNum = "";
                        unitNum = parseInt(student_usages_json[h].score);
                        decimal = 0.5;
                      } else {
                        tenNum = "";
                        unitNum = student_usages_json[h].score;
                        decimal = "";
                      }
                    } else {
                      if (student_usages_json[h].score % 1 != 0) {
                        tenNum = parseInt(student_usages_json[h].score / 10) * 10;
                        unitNum = parseInt(student_usages_json[h].score % 10);
                        decimal = 0.5;
                      } else {
                        tenNum = parseInt(student_usages_json[h].score / 10) * 10;
                        unitNum = student_usages_json[h].score % 10;
                      }
                    }
                    //console.log(tenNum,unitNum,'=====')
                    //处理没有批改的人
                    if (this.structure_type == 6) {
                      if (student_list[j].status == 20) {
                        arr_topic[i].student_usages_json.push({
                          name: student_list[j].name,
                          student_answer: student_usages_json[h].student_answer,
                          student_answer_small:
                            student_usages_json[h].student_answer_small,
                          id: student_list[j].id,
                          teacher_answer: student_usages_json[h].teacher_answer,
                          score: student_usages_json[h].score,
                          path: student_usages_json[h].path,
                          usage_id: student_list[j].id,
                          analyzing: student_usages_json[h].analyzing,
                          answer: student_usages_json[h].answer,
                          content: student_usages_json[h].content,
                          uuid: student_usages_json[h].uuid,
                          src_score: student_usages_json[h].src_score || 5,
                          childScore: student_usages_json[h].childScore,
                          tenNum: tenNum,
                          unitNum: unitNum,
                          decimal: decimal,
                        });
                      }
                    } else {
                      arr_topic[i].student_usages_json.push({
                        name: student_list[j].name,
                        student_answer: student_usages_json[h].student_answer,
                        student_answer_small: student_usages_json[h].student_answer_small,
                        id: student_list[j].id,
                        teacher_answer: student_usages_json[h].teacher_answer,
                        score: student_usages_json[h].score,
                        path: student_usages_json[h].path,
                        usage_id: student_list[j].id,
                        analyzing: student_usages_json[h].analyzing,
                        answer: student_usages_json[h].answer,
                        content: student_usages_json[h].content,
                        uuid: student_usages_json[h].uuid,
                        src_score: student_usages_json[h].src_score || 5,
                        childScore: student_usages_json[h].childScore,
                        tenNum: tenNum,
                        unitNum: unitNum,
                        decimal: decimal,
                      });
                    }
                  }
                }
              }
            }
            this.topic_list = arr_topic;
            if (this.popover_correct_type == "按人批改") {
              this.total = arr_topic.length;
              for (let i in student_list[0].student_usages_json) {
                let tenNum = "";
                let unitNum = "";
                let decimal = "";
                if (student_list[0].student_usages_json[i].score < 10) {
                  if (student_list[0].student_usages_json[i].score % 1 != 0) {
                    tenNum = "";
                    unitNum = parseInt(student_list[0].student_usages_json[i].score);
                    decimal = 0.5;
                  } else {
                    tenNum = "";
                    unitNum = student_list[0].student_usages_json[i].score;
                    decimal = "";
                  }
                } else {
                  if (student_list[0].student_usages_json[i].score % 1 != 0) {
                    tenNum =
                      parseInt(student_list[0].student_usages_json[i].score / 10) * 10;
                    unitNum = parseInt(student_list[0].student_usages_json[i].score % 10);
                    decimal = 0.5;
                  } else {
                    tenNum =
                      parseInt(student_list[0].student_usages_json[i].score / 10) * 10;
                    unitNum = student_list[0].student_usages_json[i].score % 10;
                  }
                }
                student_list[0].student_usages_json[i].tenNum = tenNum;
                student_list[0].student_usages_json[i].unitNum = unitNum;
                student_list[0].student_usages_json[i].decimal = decimal;
              }
              this.current_student_usages_json = student_list[0].student_usages_json;
              this.topic_highlig0ht = -1;
              this.student_highlight = 0;
            } else {
              this.total = student_list.length;
              this.current_student_usages_json = arr_topic[0].student_usages_json;
              this.student_highlight = -1;
              this.topic_highlight = 0;
            }
            this.change_page_size(this.page_size);

            // 进度
            let homework_class_json_info = res.data.data.homework_class_json_info;
            this.homework_class_json_info = homework_class_json_info;
          }
        });
    },
    //计算批改进度
    cacl_correct_progress() {
      let data = this.student_list;
      // console.log(JSON.parse(JSON.stringify(data)) )
      let corrected_num = 0;
      let all_num = 0;
      for (let i in data) {
        for (let j in data[i].student_usages_json) {
          all_num++;
          if (data[i].student_usages_json[j].score > -1) {
            corrected_num++;
          }
        }
      }

      this.corrected_num = corrected_num;
      this.all_num = all_num;
      this.correct_progress = (corrected_num / all_num) * 100;
    },
    cacl_correct_student() {
      let data = this.student_list;
      for (let i in data) {
        data[i].is_correct_complete = 1;
        for (let j in data[i].student_usages_json) {
          if (data[i].student_usages_json[j].score == -1) {
            data[i].is_correct_complete = 0;
          }
        }
      }
    },

    //打分
    correct_score(item, score_new) {
      // console.log(score_new)
      console.log(item, score_new);

      // return
      var formData = new FormData();
      formData.append("usages_id", item.usage_id);
      formData.append("path", item.path);
      formData.append("score", score_new);
      this.axios.post(`/school/Homework_Usages/submitScore`, formData).then((res) => {
        if (res.data.code == 1) {
          item.score = score_new;

          this.$message({
            type: "success",
            message: "批改成功",
            durtion: 1500,
            showClose: true,
          });
          for (let i in this.student_list) {
            let student_usages_json = this.student_list[i].student_usages_json;
            for (let j in student_usages_json) {
              // console.log(student_usages_json[j])
              //  if (
              //   student_usages_json[j].uuid == item.uuid &&
              //   item.usage_id == student_usages_json[j].usage_id
              // )
              if (
                item.usage_id == student_usages_json[j].usage_id &&
                student_usages_json[j].uuid == item.uuid &&
                item.path == student_usages_json[j].path
              ) {
                student_usages_json[j].score = score_new;
              }
            }
          }

          this.cacl_correct_progress();
          this.cacl_correct_student();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            durtion: 1500,
            showClose: true,
          });
        }
      });
    },
    save_canvas_imglise() {
      let userinfo = JSON.parse(sessionStorage.userInfo);
      // console.log(userinfo)

      this.call_iframe(
        {
          server_url: userinfo.school.server_url,
          token: sessionStorage.token,
          keyValue: sessionStorage.keyValue,
          school_code: userinfo.school_code,
        },
        "thumbImg"
      );
      // return
    },
    save_canvas_imglise_upload_data() {
      let item = this.current_drawer_item;
      let data = {
        path: item.path,
        usages_id: item.usage_id,
        student_answer: window.frames["newCanvas"].imgList,
      };
      //
      this.axios.post(`/school/Homework_Usages/submitTeacherAnswer`, data).then((res) => {
        if (res.data.code == 1) {
          this.drawer_correct = false;
          //  还差回显
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            durtion: 1500,
            showClose: true,
          });
        }
      });
    },
  },

  beforeDestroy() {},
};
</script>

<style>
.area_popper_batch_set_score {
  border-color: #ff9b36;
  padding: 20px 10px;
}
.area_popper_batch_set_score .popper__arrow::after {
  border-left-color: #ff9b36 !important;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course_show_student_list .popper__arrow::after {
  border-right-color: #ff9b36 !important;
}
.area_popper_course_show_student_list {
  border-color: #ff9b36;
  width: 650px;
  height: 700px;
  /* height: 400px; */
  /* padding-right: 0; */
  padding: 20px 10px;
}
.area_popper_course {
  border-color: #ff9b36;
  max-width: 50px;
  /* height: 400px; */
  padding-right: 0;
}
.color_active {
  color: #ff9b36 !important;
}
.head_l_percentage_bar .el-progress-bar {
  width: 200px;
}
.student_list_box_head .el-switch__core {
  width: 40px !important;
  height: 22px !important;
}
</style>
<style scoped>
.wrapper {
  background: #f6f6f6;
  height: calc(100vh - 122px);
  padding: 16px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
}
.head {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  border-radius: 12px;
  padding: 0 20px;
  position: relative;
}
.head_l {
  display: flex;
  align-items: center;
}
.head_l > div {
  margin-right: 20px;
}
.head_l_topic_index {
  display: flex;
  flex-wrap: wrap;
}
.head_l_topic_index > li {
  width: 30px;
  height: 30px;
  background: #f3f3f3;
  border-radius: 6px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin-right: 17px;
  cursor: pointer;
}
.box_head_l_topic_index {
  margin-bottom: 17px;
}
.head_l_topic_index_list_show_icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  cursor: pointer;
}
.head_l_percentage_title {
  margin: 0 40px;
}
.head_l_percentage_bar {
  width: 300px;
}
.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin: 2px 0;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.head_r {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.head_r > div {
  margin-left: 20px;
}
.head_r_topic_detail {
  height: 30px;
  background: #ff9b36;
  border-radius: 6px;
  line-height: 30px;
  padding: 0 20px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin: 0 20px;
}
.correct_screen_list {
  background: #ffffff;
  /* margin-top: 20px; */
  overflow: hidden;
  padding: 10px 16px;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  flex: 1;
  box-sizing: border-box;
}
.foot_page {
  height: 32px;
  padding: 10px 0 0px 0;
}
.screen_split_item {
  box-sizing: border-box;
  margin: 10px 0;
  overflow: hidden;
  /* display: flex;
        flex-direction: column; */
}

/* 分屏 */
.creen_split_1 {
  width: 100%;
  height: calc(100% - 20px);
}
.creen_split_2 {
  width: calc((100% - 20px) / 2);
  height: calc(100% - 20px);
}
.creen_split_2:nth-of-type(2n) {
  margin-left: 20px;
}

.creen_split_4 {
  width: calc((100% - 20px) / 2);
  height: calc(50% - 20px);
}
.creen_split_4:nth-of-type(2n) {
  margin-left: 20px;
}
.creen_split_6 {
  width: calc((100% - 40px) / 3);
  height: calc(50% - 20px);
}
.creen_split_6:nth-of-type(3n - 1) {
  margin-left: 20px;
  margin-right: 20px;
}
.creen_split_8 {
  width: calc((100% - 60px) / 4);
  height: calc(50% - 20px);
}
.creen_split_8:nth-of-type(4n) {
  margin-left: 20px;
}
.creen_split_8:nth-of-type(4n -1) {
  margin-left: 20px;
}
.creen_split_8:nth-of-type(4n -2) {
  margin-left: 20px;
}
/*  */
.correct_screen_list_item_head {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  align-items: center;
  color: #ff9b36;
  /* background: red; */
  margin: 0 0 10px 0;
}
.correct_screen_list_item_head_opreation {
  display: flex;
}
.correct_screen_list_item_head_opreation > div {
  margin: 0 10px;
  cursor: pointer;
  color: #999999;
  background: transparent;
  min-width: 30px;
  height: 60px;
  text-align: center;
}
.correct_screen_list_item_head_opreation > div:hover {
  background: #ff9b36;
  color: white;
}
.correct_screen_list_item_canvas {
  flex: 1;
  /* background: green; */
  margin: 10px;
  border: 1px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  overflow: auto;
}
.correct_screen_list_item_main_box {
  border: 4px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
}
.correct_screen_list_item_foot_opreation {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  padding: 0 10px;
}
.correct_screen_list_item_foot_opreation_save {
  cursor: pointer;
}
.correct_screen_list_item_foot_opreation_mark {
  display: flex;
}
/* .correct_screen_list_item_foot_opreation_mark > div {
  width: 40px;
  height: 40px;
  background: #f3f3f3;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 20px;
  text-align: center;
  line-height: 40px;
  font-size: 30px;
  color: #666666;
} */
.show_student_list {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  bottom: 0px;
}
.student_list_box_head {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  /* width: 650px; */
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  align-items: center;
}
.student_list_box_head_show_list {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.student_list_box_head_content {
  max-height: 650px;
  margin: 20px;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
}
.student_list_box_head_content > div {
  width: 144px;
  height: 54px;
  background: #ff9b36;
  border-radius: 12px;
  /* padding: 0 20px; */
  text-align: center;
  line-height: 54px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  background: #f3f3f3;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 20px;
}
.student_list_box_head_content > div:nth-of-type(3n - 1) {
  margin: 0 81px;
}
.drawer_correct_canvas {
  height: calc(100% - 30px);
  width: calc(100% - 60px);
  margin: 0 30px 30px 30px;
  /* border: 4px solid #69B4FF; */
}
.is_correct_active {
  background: #69b4ff !important;
  color: #ffffff !important;
}
.show_canvas_operation_type_active {
  background: #ff9b36 !important;
  color: #ffffff !important;
}
.topic_highlight {
  background: #ff9b36 !important;
  color: #ffffff !important;
}
.student_highlight {
  background: #ff9b36 !important;
  color: #ffffff !important;
}
.batch_set_score {
  margin-left:100px;
  width: 120px;
  height: 40px;
  background: #69b4ff;
  box-sizing: border-box;
  z-index: 9999;
  color: #fff;
  text-align: center;
  line-height: 40px;
}
.batch_set_score > div {
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  height: 25px;
  line-height: 25px;
}
.set_score_all:hover {
  background: #69b4ff !important;
  color: #ffffff !important;
}
.correct_screen_list_item_foot_opreation_show_topic {
  margin-right: 20px;
  cursor: pointer;
}
.tenBoxItem {
  width: 25px;
  height: 25px;
  font-size: 14px;
  border: 0.5px solid #69b4ff;
  cursor: pointer;
}
.unitListItem {
  width: 25px;
  height: 25px;
  font-size: 14px;
  border: 0.5px solid #69b4ff;
  cursor: pointer;
}
.scoreBox {
  width: 25px;
  height: 25px;
  font-size: 14px;
  border: 0.5px solid #69b4ff;
  cursor: pointer;
  text-align: center;
  line-height: 25px;
}
.tenBoxItemActive {
  background: #69b4ff;
  color: #fff;
}
.unitListItemActive {
  background: #69b4ff;
  color: #fff;
}
.scoreBoxActive {
  background: #69b4ff;
  color: #fff;
}
.gradeBox {
  padding: 10px 0px;
}
.Uncorrected {
  color: red !important;
}
.content_box {
  height: calc(100vh - 240px);
}
.content_left {
  flex: 1;
  height: 100%;
}

.content_right {
  width: 140px;
  height: 90%;
  margin-left: 16px;
  margin-top: 20px;
  margin-right: 16px;
  /* padding: 10px 16px; */
}
.content_right_head {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border-radius: 12px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  box-sizing: border-box;
  margin-bottom: 16px;
  padding: 0px 10px;
}
.content_right_head_item {
  margin-right: 30px;
}
.content_right_head_active {
  color: #54a9fd;
}
.content_right_head_item_line {
  width: 24px;
  height: 5px;
  background: #54a9fd;
  border-radius: 3px;
  margin-top: 5px;
}
.content_right_head_item > span {
  cursor: pointer;
}
.content_right_content {
  background: #ffffff;
  border-radius: 12px;
  flex: 1;
  overflow-y: auto;
}
.content_right_content_title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
  padding: 15px;
}
.content_right_content_list {
  flex-wrap: wrap;
}
.content_right_content_list_item {
  width: 32px;
  height: 32px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  margin: 10px;
  cursor: pointer;
  box-sizing: border-box;
}
.content_right_content_list_item_active {
  background: #e1f0ff;
  border: 1px solid #69b4ff;
  color: #69b4ff;
  box-sizing: border-box;
}
.student_item {
  padding: 5px 10px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  cursor: pointer;
}
.student_item_active {
  background: #e1f0ff;
  color: #69b4ff;
}
.student_item_error {
  color: red;
}
.content_left_head {
  height: 40px;
  background: #fff;
  margin-top: 20px;
}
.content_left_head_box {
  margin: 5px 15px;
  width: 120px;
}
.lastBox {
  position: absolute;
  top: 50%;
  z-index: 999;
  width: 60px;
  height: 60px;
  left: 30px;
}
.content_left {
  position: relative;
}
.lastBox img {
  width: 100%;
  height: 100%;
}
.nextBox {
  position: absolute;
  top: 50%;
  right: 30px;
  z-index: 999;
  width: 60px;
  height: 60px;
}
.nextBox img {
  width: 100%;
  height: 100%;
}
.pageItem {
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.pageItemActive {
  background: #69b4ff;
  color: #fff;
}
</style>
